<template>
  <!-- 考试页面 -->

  <popup ref="popup" :loading="popupLoading" @beforeClose="close">
    <div slot="body" style="padding-top: 20px">

      <div class="operator">
        <el-row>
          <el-col :span="5">
            <span class="text">
              <el-tooltip class="item" effect="dark" :content="studentNeedList" placement="bottom">
                <span> 已考 / 应考人数 ： {{ corectCnt }}/ {{ needExmCnt }}</span>
              </el-tooltip></span>
          </el-col>

          <el-col :span="5">

            <el-button :type="stuIndex < 1 ? '' : 'primary'" size="mini" :disabled="stuIndex < 1"
              @click="moveStu(-1)">《《</el-button>
            <el-button :content="studentNeedList" type="success" size="mini"> ({{ stuIndex + 1 }}) {{ student.name
            }}</el-button>
            <el-button :type="stuIndex > (studentList.length - 2) ? '' : 'primary'" size="mini"
              :disabled="stuIndex > (studentList.length - 2)" @click="moveStu(1)">》》</el-button>
            <el-button type="warning" size="mini" v-show="!this.stuAnwser.isjudged" @click="submitPigai()">完成</el-button>
          </el-col>
          <el-col :span="3">
            当前得分：{{ score }} / {{ maxScore }}
          </el-col>
          <el-col :span="11">

          </el-col>
        </el-row>
      </div>
      <el-form class="dataForm" ref="form" :disabled="disabled" :inline="true">
        <el-row>
          <el-col :span="24">
            <!-- 简答、论述、编程题 -->
            <el-card v-if="stuQueArray[0]" v-for="(qu, idx1) in stuQueArray" :key="idx1 + '5'">
              <div v-if="idx1 == 0"><el-divider content-position="left"> <span
                    style="color:#CC0000">面试问答</span></el-divider>
              </div>
              <b>{{ idx1 + 1 }}</b> <b>{{ qu.question.title }}</b>
              <b style="color:#00CC00">[{{ qu.qscore }}分]</b>
              判定得分：<input :disabled="stuAnwser.isjudged > 0" @blur="checkOutScore(qu, $event)" @focus="checkInScore"
                size="4" type="text" v-model="qu.rscore" />分。
              <div style="width: 50%">
                 
                <span class="title-color-red">标准答案： <span style="color: #777;font-size: 12px;"
                    v-html="qu.rigthAnsr"></span></span>
                <br>
                <span class="title-style-bold margin-top-20">题目解析:</span><br>
                <!-- 题目解析按钮 -->
                <el-button type="primary" size="mini" @click="getCurrentAnalysis(qu)">查看解析</el-button>
              </div>
            </el-card>


          </el-col>
        </el-row>
      </el-form>

      <!-- 解析弹出面板 -->
      <el-dialog title="编辑" :visible.sync="dialogFormVisible" :append-to-body="true" ref="analysisForm">
        <el-form :model="currentAnalysis">
          <el-form-item label="题目解析">
            <el-input type="textarea" v-model="currentAnalysis.analysis" rows="6"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="resetForm('cancel')">关 闭</el-button>
        </div>
      </el-dialog>
    </div>
    <div slot="footer">
      <el-row>
        <el-col :span="21">
          <el-button v-if="!disabled" type="primary" :loading="confirmLoading" @click="close()">关 闭</el-button>
        </el-col>
        <el-col :span="3">
        </el-col>
      </el-row>
    </div>
  </popup>
</template>
<script>
import popup from "@/components/popup/drawerPopupSta.vue";
import FillInTheBlanks from "@/components/exams/FillInTheBlanks.vue";
import api from "@/api/exams/exams/exams.js";
import rptapi from "@/api/exams/exams/rpt_answers.js";
import questionApi from "@/api/exams/question/question.js";
import ansrApi from "@/api/exams/answers/answers.js";

export default {
  components: {
    popup,
    FillInTheBlanks
  },
  data() {
    return {
      countDown: "",
      popupLoading: false,
      disabled: false,
      confirmLoading: false,

      exam: {},              //exam
      kid: '',                //考试id
      studentList: [],        //已考学生列表

      studentNeedList: "",    //应考学生列表

      student: {},            //当前批改的学生 
      stuIndex: 0,            //当前批改的学生 在数组中的位置
      exp: {},                //试卷
      expId: null,            //试卷ID
      needExmCnt: 0,          //该考试的人数
      corectCnt: 0,           //已批改人数
      score: 0,               //当前得分

      maxScore: 0,            //试卷总分
      typeTxArr: [],
      stuAnwser: { isjudged: 0 },           //学生答案

      qscore: 0,  //每题得分

      //改分前的得分
      lastRscore: 0,

      //题类型位置
      choice_question: { show: false },
      //总题数组
      questionArray: [],
      //当前学生的题目
      stuQueArray: [],

      dialogFormVisible: false, // 题目解析弹出是否可见
      currentAnalysis: {}    // 当前题目的解析

    };
  }, methods: {

    //给每个考生随机生成题目
    genRdmArr() {


      //重新取得学生的答案 如果该学生已提交
      api.getOneAnswers({ kid: this.kid, sid: this.student.id }, res => {

        if (res.data) {  //已考
          //record
          this.stuAnwser = res.data
          this.score = this.stuAnwser.score
          //试题id
          this.stuQueArray = JSON.parse(this.stuAnwser.answer)

          //手动强制刷新
          this.$forceUpdate()
        } else {
          //随机出题
          let q_idxArr = new Set()
          while (q_idxArr.size < this.exam.quenum) {
            q_idxArr.add(Math.floor(Math.random() * this.questionArray.length))
          }
          //添加题目
          //reset
          this.stuQueArray = []

          q_idxArr.forEach(v => {
            //克隆
            let oneq = JSON.parse(JSON.stringify(this.questionArray[v]));
            oneq.qscore = this.qscore;
            this.stuQueArray.push(oneq);
          })
        }
       // console.log("this.questionArray", this.questionArray)
       // console.log("this.stuQueArray", this.stuQueArray)
      })
    },
    submitPigai() {

     // console.log("this.stuQueArray",this.stuQueArray)

      let count =0;
      this.stuQueArray.forEach(v=>{
           if(v.rscore || v.rscore==0){
              count++
           }
      })
      if( count < this.exam.quenum ){
 
         this.$alert('提交出错', '请对每道题进行评分！' );

         return false;
      }

      //询问是否完成批改？完成批改  ： 暂存成绩
      this.$confirm('是否提交当前成绩？', '试卷批改提示', {
        distinguishCancelAndClose: true, confirmButtonText: '提交', cancelButtonText: '取消'
      }).then(() => {

     


        //第一个 卷封装答案
        let record = {
          isjudged: 1, kid: this.kid, cid: this.exam.cid, sid: this.student.id, score: this.score, expid: this.expId, type: 2,
          answer: this.stuQueArray
        }

        //提交判卷
        ansrApi.save(record, res => {
          this.$utils.msg.success(res.msg);
          this.corectCnt += 1
          this.stuAnwser.isjudged = 1

         //提交统计数据
          for (let i = 0; i < this.stuQueArray.length; i++) {
             let parameter = { sid: this.student.id, exmid: this.kid, tname: this.$caches.user.get().name, qid: this.stuQueArray[i].id, qnm: this.stuQueArray[i].question.title, rscore: this.stuQueArray[i].qscore, score: this.stuQueArray[i].rscore }
              rptapi.save(parameter, res => {
               //
             }, err => {
             this.$utils.msg.warning(err.msg);
            })
          }

        }, err => {
          this.$utils.msg.warning(err.msg);
        })

      })
    },
    moveStu(flag) {

      //下一位
      this.stuIndex += flag
      this.student = this.studentList[this.stuIndex]
      this.score = 0;
      this.stuAnwser = { isjudged: 0 }
      this.genRdmArr()

    },//初始化学生答案对象
    initPaper() {

      //试卷中的试题ID---->试题
      api.getexpContent({ expid: this.expId }, (response) => {
        //试卷
        this.exp = JSON.parse(response.data);

        //this.maxScore = this.exp.score;
        this.maxScore = 100;

        //题型
        let content = JSON.parse(this.exp.content)

        this.typeTxArr = content.types;
        this.typeTxArr.forEach((v, i) => {
          //初始化答案
          let qscore = content.contents[i].qscore
          //回显答案
          this.exp.contents[i].qid.forEach((v1, i1) => {
            v1.qscore = qscore[i1]
          })
          //所有题型都放入简答
          this.questionArray = [...this.questionArray, ...this.exp.contents[i].qid]
        });

        this.genRdmArr()
      });
    },
    //打开弹框
    open(kid, title, disabled) {
      this.kid = kid;
      // 加载试卷+考试
      api.findPaperByKid({ kid: this.kid }, res => {
        //考试
        this.exam = res.data.exm
        //100分制计算每题得分
        this.qscore = Math.floor(100 / this.exam.quenum)

        //试卷ID
        this.expId = this.exam.expid

        //已批改的人数
        this.corectCnt = res.data.corectCnt

        //参加考试的学生
        this.studentList = res.data.students


        this.studentNeedList = this.exam.sid

        this.needExmCnt = JSON.parse(this.studentNeedList).length

        this.student = this.studentList[this.stuIndex]

        //初始化第一个学生答案
        this.initPaper();

        this.$refs.popup.open(title, "100%");
        //2. 发起请求 根据  考试ID +学生ID 查回一个试卷+答案

        this.disabled = disabled;
      })

    }, checkInScore($event) {

      if ($event.target.value) {
        let sc = $event.target.value * 1
        this.score -= sc
        // if (sc > 10 || sc< 0){
        //   this.score += sc
        // }
        $event.target.value = 0;
        this.lastRscore = 0
      }

    }, checkOutScore(qu) {

      if (isNaN(qu.rscore)) {
        this.$utils.msg.warning("输入错误");
        qu.rscore = "0"
        return;
      } else {
        if (qu.rscore < 0 || qu.rscore > qu.qscore) {
          this.$utils.msg.warning("得分越界");
          qu.rscore = "0"
          return;
        }
      }
      // this.lastRscore
      if (this.lastRscore) {
        this.score -= this.lastRscore
      }

      // 总分
      this.score += qu.rscore * 1
      //复位  this.lastRscore 作用域只作用于 点进 - 点出 之间。
      qu.rslt = (qu.rscore == qu.qscore ? 1 : (qu.rscore == 0 ? 0 : 2))
      this.lastRscore = 0
    },
    close() {
      this.disabled = false;
      this.$refs.popup.closeCallback();
      //退出初始化参数
      this.score = 0;
      this.countDown = "";
      this.popupLoading = false;
      this.disabled = false;
      this.confirmLoading = false;
      this.exam = {};
      this.choice_question = { show: false };

      this.currentAnalysis = {};
      this.stuIndex = 0;
      this.examPapers = {}    //伪数组  :把对象当数组用，实现'键值对'Map

      this.student = {}

      this.score = 0,         //当前得分

        this.maxScore = 0,    //试卷总分

        //改分前的得分
        this.lastRscore = 0

      //备选题
      this.questionArray = [];
      this.$parent.list();

    },

    // 初始化题目解析表单
    resetForm(status) {

      this.dialogFormVisible = false;
    },
    // 获取当前题目的解析内容
    getCurrentAnalysis(data) {
      this.currentAnalysis = data;
      this.dialogFormVisible = true;
    },
    // 更新题目信息
    updateQuestion() {
      let params = this.$utils.merger(this.currentAnalysis);
      questionApi.update(params, (response) => {
        this.$utils.msg.success(response.msg);
      })
    }

  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
@import "~common/custom/css/popup/popup.scss";

.el-row {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}

.el-col {
  border-radius: 4px;
}

.bg-purple-dark {
  background: #99a9bf;
}

.bg-purple {
  background: #d3dce6;
}

.bg-purple-light {
  background: #e5e9f2;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}

.text {
  display: inline-block;
  padding: 0 20px;
}

.operator {
  position: absolute;
  top: 50px;
  width: 100%;
  background-color: rgba(255, 255, 255, .8);
  z-index: 999;
}

.title-style-bold {
  color: #000;
  font-weight: bold;
}

.title-color-red {
  color: red;
}

.margin-top-20 {
  margin-top: 20px;
  display: block;
}

.update-note {
  display: block;
  margin-top: 20px;
}</style>